import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button, Typography } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import RemoveTextButton from '../atoms/RemoveTextButton';
import AddGochiKidTextButton from '../atoms/AddGochiKidTextButton';
import listMenuChildTypes from '../../constants/MenuChildType';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textDelete: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  },
  iconSetting: {
    marginLeft: 5
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      menuChildType: PropTypes.number,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    menus,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    removeOpenAction,
    order,
    orderBy,
    isAddGochiKidMenu,
    addOpenAction,
    classes,
    openSettingMenuFreeModalAction
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
              gochiMenu.groupName
            }`;

            return (
              <TableRow key={key} hover>
                <TableCell>{gochiMenu.menuId}</TableCell>
                <TableCell>{gochiMenu.menuName}</TableCell>
                <TableCell>
                  {listMenuChildTypes.map(item => {
                    if (parseInt(gochiMenu.menuChildType, 10) === item.id) {
                      return item.name;
                    }
                    return '';
                  })}
                </TableCell>
                <TableCell>{gochiMenu.shopId}</TableCell>
                <TableCell>{gochiMenu.shopName}</TableCell>
                <TableCell>{gochiMenu.groupId}</TableCell>
                <TableCell>{gochiMenu.groupName}</TableCell>
                <TableCell>{gochiMenu.excludedTaxPrice}</TableCell>
                <TableCell>{gochiMenu.includedTaxPrice}</TableCell>
                <TableCell>
                  <Button
                    onClick={() =>
                      openSettingMenuFreeModalAction(gochiMenu.menuId)
                    }
                  >
                    {gochiMenu.gochiKidFreeFlag === 1 ? (
                      <Typography color="primary">ON</Typography>
                    ) : (
                      <Typography>OFF</Typography>
                    )}
                    <SettingsIcon
                      color="primary"
                      className={classes.iconSetting}
                    />
                  </Button>
                </TableCell>
                <TableCell>
                  {!isAddGochiKidMenu && (
                    <Button
                      color="primary"
                      onClick={() => detailOpenAction({ id: gochiMenu.menuId })}
                    >
                      詳細
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  {!isAddGochiKidMenu ? (
                    <RemoveTextButton
                      id={gochiMenu.menuId}
                      onClickAction={removeOpenAction}
                    />
                  ) : (
                    <AddGochiKidTextButton
                      id={gochiMenu.menuId}
                      onClickAction={addOpenAction}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
